"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MANAGER_LAYOUT_STYLING = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var basicClasses = (0, _classnames.default)('flex relative w-full no-underline pl-[26px] justify-start items-center text-white', 'active:text-white before:h-full before:w-[6px] before:absolute before:left-0 before:top-0', "hover:text-white hover:before:h-full hover:before:content-['|'] hover:before:absolute", 'hover:before:left-0 hover:before:top-0 hover:before:w-[6px] focus:text-white');
var clinicianClasses = 'bg-blue1-60 hover:bg-blue1-50 hover:before:bg-blue1-10 hover:before:text-blue1-10';
var adminClasses = 'bg-green1-65 hover:bg-green1-50 hover:before:bg-green1-10 hover:before:text-green1-10';
var navItemActiveGeneralClasses = "before:content-['|'] before:w-[6px] before:absolute before:left-0 before:top-0";
var navItemActiveClinicianClasses = 'bg-blue1-50 before:bg-blue1-10';
var navItemActiveAdminClasses = 'bg-green1-50 before:bg-green1-10';
var MANAGER_LAYOUT_STYLING = {
  adminStyles: {
    navItemDefaultClassNames: (0, _classnames.default)(basicClasses, adminClasses),
    navItemActiveClassNames: (0, _classnames.default)(navItemActiveGeneralClasses, navItemActiveAdminClasses)
  },
  clinicianStyles: {
    navItemDefaultClassNames: (0, _classnames.default)(basicClasses, clinicianClasses),
    navItemActiveClassNames: (0, _classnames.default)(navItemActiveGeneralClasses, navItemActiveClinicianClasses)
  }
};
exports.MANAGER_LAYOUT_STYLING = MANAGER_LAYOUT_STYLING;